import React, { forwardRef, useEffect, useRef, useState } from "react";

const CustomModel = forwardRef(
  ({ show, children, heading, handleCancel, width, isVisible }, ref) => {
    const [offset, setOffset] = useState({ x: 0, y: 0 });
    const [position, setPosition] = useState({ x: 100, y: 100 }); // Use pixels
    const modalRef = useRef(null);
    const [isDragging, setDragging] = useState(false);
    const [size, setSize] = useState({ width: 500, height: 400 });

    useEffect(() => {
      if (isDragging) {
        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
      } else {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
      }

      return () => {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
      };
    }, [isDragging]);

    const handleMouseDown = (e) => {
      if (["INPUT", "TEXTAREA", "BUTTON", "SELECT", "LABEL"].includes(e.target.tagName)) {
        return;
      }

      e.preventDefault();

      const rect = modalRef.current.getBoundingClientRect();
      setOffset({
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
      });

      setDragging(true);
    };

    const handleMouseMove = (e) => {
      e.preventDefault();

      let newX = e.clientX - offset.x;
      let newY = e.clientY - offset.y;

      // Clamp modal within the viewport
      const modalWidth = modalRef.current.offsetWidth;
      const modalHeight = modalRef.current.offsetHeight;

      newX = Math.max(0, Math.min(newX, window.innerWidth - modalWidth));
      newY = Math.max(0, Math.min(newY, window.innerHeight - modalHeight));

      setPosition({ x: newX, y: newY });
    };

    const handleMouseUp = () => {
      setDragging(false);
    };

    return (
      <div
        style={{
          position: "absolute",
          left: position.x,
          top: position.y,
          backgroundColor: "#fff",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          padding: "16px",
          zIndex: 1000,
          width: width ? width : "30%",
          borderRadius: "16px",
        }}
      >
        <div className="flex flex-col">
          <div ref={modalRef} className="w-full p-2 border-b-[1px] border-grey">
            <div
              ref={ref}
              className="w-full flex justify-between"
              onMouseDown={handleMouseDown}
              style={{ cursor: "move", userSelect: isDragging ? "none" : "auto" }}
            >
              <heading className="text-[16px] font-semibold">{heading}</heading>
              <button
                onClick={() => handleCancel()}
                className="font-semibold py-1 px-2 border-black rounded-[8px] shadow-md"
              >
                x
              </button>
            </div>
          </div>
          <div>{children}</div>
        </div>
      </div>
    );
  }
);

export default CustomModel;
